import React from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMReservationTabView from 'components/dashboard/shared/SMReservationTabView';
import SMReservationContainerView from 'components/dashboard/shared/SMReservationContainerView';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMRestClient from 'lib/SMRestClient';
import SMUReservationListTableRow from './SMUReservationListTableRow';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import sprintf from 'sprintf';
import Spinner from 'components/shared/SMMaterialSpinner';
import reactMixin from 'react-mixin';

class SMUReservationListView extends SMDashboardBaseView {
  
  constructor(props) {
    super(props);
    this.currentPage = this.props.page;
    this.canRequest = true;
    this.state = {
      display: this.props.display,
      status: this.props.status,
      spaceId: this.props.spaceId,
      roomId: this.props.roomId,
      start: this.props.start,
      end: this.props.end,
      keyword: this.props.keyword,
      isMessageView: this.props.isMessageView || false,
      listItems: [],
      selectedRowIndex: -1,
      shouldShowReview: false, 
      user: this.props.user,
      pushStateUrl: "",
    };
  }
  
  componentDidMount() {
    $('body').addClass('js-split-view');
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    
    this.sizeToFit();
    this.applyResponsive();
    SMRenderHelper.addObserverForBaloon();
    
    if (SMAppHelper.isMobileMainCol()) $(this.refs.mainTable).startLoading({modalOpacity:0});
    if (this.props.reservationId) {
      this.setState({display: SMConst.Display.Loading});
      SMUserResource.getReservation(this.state.user.username, this.props.reservationId, (reservation, error, xhr)=>{
        if (SMAppHelper.isMobileMainCol()) $(this.refs.mainTable).stopLoading();
        this.setState({display: SMConst.Display.Visible});
        if(error) return;
        this.canRequest = false;
        this.setState({
          shouldShowReview: (window.location.hash == "#review"),
          listItems: [reservation],
          keyword: reservation.id,
          reservation: reservation,
          isMessageView: this.props.isMessageView,
          selectedRowIndex: 0,
          pushStateUrl: Routes.dashboard_reservation_path(reservation.uid),
        });
      });
    } else {
      this.requestResource();
    }
    
    this.addSplitViewModal(this.refs.mainTable);
    const self = this;
    $(".js-datepicker").datepicker({dateFormat:"yymmdd", onClose:function(e){
      let state = Object.assign({}, self.state);
      state[this.name] = this.value;
      self.setState(state);
    }});
    
    SMHistoryHelper.observePopState((state)=>{
      this.setState(state);
    });
  }
  
  spaceSelectBoxDidChangeValue(value) {
    this.setState({spaceId: value, roomId: ""});
  }
  
  roomSelectBoxDidChangeValue(value) {
    this.setState({roomId: value});
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
    this.removeSplitViewModal();
  }
  
  componentWillUpdate(nextProps, nextState) {
    let scroller =  SMAppHelper.isMobile() ? window : this.refs.navigationTable;
    $(scroller).off("scroll", this.tableViewDidScroll);
  }
  
  componentDidUpdate(prevProps, prevState) {
    let scroller =  SMAppHelper.isMobile() ? window : this.refs.navigationTable;
    $(scroller).on("scroll", this.tableViewDidScroll.bind(this));
    
    let reservation = this.state.listItems[this.state.selectedRowIndex];
    if (this.state.pushStateUrl != prevState.pushStateUrl && reservation) {
      SMHistoryHelper.replaceState(this.state.pushStateUrl, this.state);
      SMAppHelper.setTitle(sprintf(I18n.t("dashboard.label_000116"), reservation.id));
    }
  }
  
  tableViewDidScroll(e){
    SMAppHelper.observeScrollToBottom(e.currentTarget, ()=>{
      this.requestResource(true);
    });
  }
  
  sizeToFit(e) {
    let $mainTable = $(this.refs.mainTable),
        $navigationTable = $(this.refs.navigationTable);
        
    $navigationTable.outerHeight(this.navigationTableHeight());
    let $subHeader = $(this.refs.headerSubNavigation);
    let $mainTableFooter = $('#js-dashboard-main-table-footer');
    let mainTableFooterHeight = $mainTableFooter ? $mainTableFooter.outerHeight() : 0;
    $mainTable.outerHeight(this.mainTableHeight() - $subHeader.outerHeight() - mainTableFooterHeight);
  }
  
  requestResource(isAppend, callback){
    if (!this.canRequest) return;
    this.canRequest = false;
    if (!isAppend) this.setState({display: SMConst.Display.Loading});
    let queries = {};
    if (this.state.status) queries["status"] = this.state.status;
    if (this.state.spaceId) queries["space_id"] = this.state.spaceId;
    if (this.state.roomId) queries["room_id"] = this.state.roomId;
    if (this.state.start) queries["start"] = this.state.start;
    if (this.state.end) queries["end"] = this.state.end;
    if (this.state.keyword) queries["keyword"] = this.state.keyword;
    let pushStateUrl = Routes.dashboard_reservations_path(queries);
    
    queries["sort"] = "created";
    queries["search_fields"] = "user_contact,id";
    if (this.currentPage != 1) queries["page"] = this.currentPage;
    
    SMUserResource.searchReservations(this.state.user.username, queries, (responses, error, xhr)=>{
      this.setState({display: SMConst.Display.Visible});
      if(error || !responses) return;
      let links = SMRestClient.getLinks(xhr),
          listItems = this.state.listItems;
      if (links["next"]) {
        this.canRequest = true;
      }
      listItems = update(listItems, {$push: responses});
      
      this.currentPage++;
      let state = {listItems: listItems};
      if (!isAppend) state["pushStateUrl"] = pushStateUrl;
      this.setState(state);
    });
  }
  
  tableDidSelectRowAtIndex(rowIndex, e) {
    if (!SMAppHelper.isMobile()) e.preventDefault();
    
    let reservation = this.state.listItems[rowIndex];
    let url = Routes.dashboard_reservation_path(reservation.uid);
    this.setState({
      selectedRowIndex: rowIndex,
      shouldShowReview: false,
      pushStateUrl: url,
      // isMessageView: false,
    });
    this.hideDialog();
    if (!SMAppHelper.isMobile()) SMTrackHelper.pageView(url);
  }
  
  messageDidReadRowAtIndex(rowIndex) {
    let reservation = this.state.listItems[rowIndex];
    let listItems = this.state.listItems;
    reservation.is_read_message = true;
    listItems[rowIndex] = reservation;
    this.setState({
      listItems: listItems,
    });
  }
  
  renderList() {
    if (this.state.listItems.length > 0) {
      let reservationList = [];
      for (let rowIndex = 0; rowIndex < this.state.listItems.length; rowIndex++) {
        let isCurrent = this.state.selectedRowIndex == rowIndex,
            reservation = this.state.listItems[rowIndex];
        reservationList.push(
          <SMUReservationListTableRow 
            key={reservation.id} 
            reservation={reservation}
            delegate={this}
            rowIndex={rowIndex}
            isCurrent={isCurrent} />
        );
      }
      if (this.canRequest) {
        reservationList.push(
          <p key="loading" className="js-loading-row">読み込んでいます...</p>
        );
      }
      return (
        <ul>
          <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
            {reservationList}
          </CSSTransitionGroup>
        </ul>
      );
    }
    return <p className="dashboard-sidecol__scrollarea-nodata">予約はまだありません。</p> ;
  }
  
  renderStatusSelect(){
    let rows = [];
    let statuses = {
      "all": ["all", I18n.t("dashboard.label_000073")],
      "requested": ["requested", I18n.t("dashboard.label_000074")],
      "confirmed": ["confirmed,paying", I18n.t("dashboard.label_000075")],
      "paid": ["paid", I18n.t("dashboard.label_000076")],
      "cancelled": ["cancelled", I18n.t("dashboard.label_000077")],
    };
    for (let key in statuses) {
      let value = statuses[key];
      rows.push(
        <option key={key} value={value[0]}>{value[1]}</option>
      );
    }
    return rows;
  }
  
  queryDidChange(e){
    let state = this.state;
    state[e.currentTarget.name] = e.currentTarget.value;
    this.setState(state);
  }
  
  formDidSubmit(e){
    this.currentPage = 1;
    this.canRequest = true;
    this.setState({
      selectedRowIndex: -1,
      shouldShowReview: false,
      listItems: [],
    });
    this.requestResource();
    e.preventDefault();
  }
  
  formDidReset(e){
    e.preventDefault();
    this.currentPage = 1;
    this.canRequest = true;
    this.setState({
      status: "",
      spaceId: "",
      roomId: "",
      start: "",
      end: "",
      keyword: "",
      selectedRowIndex: -1,
      listItems: [],
    });
    setTimeout(()=>{
      this.requestResource();
    },1);
  }
  
  showReservationView(){
    this.setState({isMessageView: false});
  }
  
  showMessageView(){
    this.setState({isMessageView: true});
  }
  
  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }
  
  reservationDidCancel(reservation, rowIndex, xhr) {
    let replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  }

  unapprovedReservationDidConfirm(reservation, rowIndex, xhr) {
    let replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  }

  unapprovedReservationDidFailToConfirm(reservation, rowIndex, xhr) {
    let replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  }
  
  unapprovedReservationDidReject(reservation, rowIndex, xhr) {
    let replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  }

  unapprovedReservationDidFailToReject(reservation, rowIndex, xhr) {
    let replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  }
  
  messageDidClose(reservation, rowIndex, xhr) {
    let replace = {};
    replace[rowIndex] = {$set: reservation};
    this.setState({listItems: update(this.state.listItems, replace)});
  }
  
  
  render() {
    
    let reservation = this.state.listItems[this.state.selectedRowIndex],
        user = this.state.user,
        keyword = this.state.keyword || "";
    let mainTableDisplay, navigationTable;
    
    if (reservation) mainTableDisplay = SMConst.Display.Visible;
    else if (this.props.reservationId) mainTableDisplay = SMConst.Display.Hidden;
    else mainTableDisplay = SMConst.Display.Init;
    
    if (this.state.display == SMConst.Display.Loading) navigationTable = this.renderLoading();
    else navigationTable = this.renderList();
    
    return (
      <div ref="container" className="dashboard-container clearfix mb30">

        <div ref="headerSubNavigation" className="dashboard-search">
          <form onSubmit={this.formDidSubmit.bind(this)} action={Routes.dashboard_reservations_path()}>
            ステータス
            <span className="form-select__inner mr10 ml5">
              <label className="form-select__s">  
                <select name="status" value={this.state.status} onChange={this.queryDidChange.bind(this)} className="dashboard-search__form w110">
                  {this.renderStatusSelect()}
                </select>
              </label>
            </span>
            期間
            <input name="start" value={this.state.start} onChange={this.queryDidChange.bind(this)} type="text" className="js-datepicker dashboard-search__form ml5 mr5 w70" placeholder="20160101" />〜
            <input name="end" value={this.state.end} onChange={this.queryDidChange.bind(this)} type="text" className="js-datepicker dashboard-search__form mr10 ml5 w70" placeholder="20161231" />
            {I18n.t("dashboard.label_000088")}
            <input name="keyword" value={decodeURIComponent(keyword)} onChange={this.queryDidChange.bind(this)} type="text" className="dashboard-search__form mr10 ml5 w150" />
            <input className="button-blue dashboard-search__button mr5" type="submit" value={I18n.t("dashboard.label_000091")} />
            <input onClick={this.formDidReset.bind(this)} className="button-gray dashboard-search__button mr8" type="button" value={I18n.t("dashboard.label_000136")} />
          </form>
        </div>

        <div className="dashboard-sidecol fl">
          <h2 className="dashboard-title mt25 mb25 ml20">{I18n.t("dashboard.label_000086")}</h2>
          <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
            {navigationTable}
          </div>
        </div>

        <div ref="mainTable" id="js-split_view-main" className="js-scroller dashboard-maincol__right reserve-maincol__right">
          <SMReservationTabView
            reservation={reservation}
            isMessageView={this.state.isMessageView}
            delegate={this} />
          <SMReservationContainerView 
            user={this.props.user}
            isOwner={false}
            isMessageView={this.state.isMessageView}
            reservation={reservation} 
            shouldShowReview={this.state.shouldShowReview}
            display={mainTableDisplay}
            delegate={this}
            rowIndex={this.state.selectedRowIndex}
             />
        </div>

      </div>
    );
  }
}
SMUReservationListView.defaultProps = {
  display: SMConst.Display.Visible,
  status: "",
  spaceId: "",
  roomId: "",
  start: "",
  end: "",
  keyword: "",
  page: 1,
};
SMUReservationListView.propTypes = {
  user: PropTypes.object.isRequired,
  page: PropTypes.number,
  reservationId: PropTypes.string,
  status: PropTypes.string,
  spaceId: PropTypes.string,
  roomId: PropTypes.string,
  start: PropTypes.string,
  end: PropTypes.string,
  keyword: PropTypes.string,
};
reactMixin(SMUReservationListView.prototype, SMSplitViewMixin);
export default SMUReservationListView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationListView.jsx